import React from "react";

const BookingErrorIcon = () => {
  return (
    <svg
      width="373"
      height="372"
      viewBox="0 0 373 372"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <circle cx="186.979" cy="50.4708" r="13.6097" fill="#D04729" />
        <circle
          cx="142.771"
          cy="21.009"
          r="17.1526"
          transform="rotate(-15 142.771 21.009)"
          fill="#D04729"
        />
        <circle
          cx="90.6443"
          cy="89.6666"
          r="13.6807"
          transform="rotate(-45 90.6443 89.6666)"
          fill="#D04729"
        />
        <circle
          cx="38.2797"
          cy="100.149"
          r="17.2421"
          transform="rotate(-60 38.2797 100.149)"
          fill="#D04729"
        />
        <circle
          cx="322.508"
          cy="186.001"
          r="13.6097"
          transform="rotate(90 322.508 186.001)"
          fill="#D04729"
        />
        <circle
          cx="351.971"
          cy="141.791"
          r="17.1526"
          transform="rotate(75 351.971 141.791)"
          fill="#D04729"
        />
        <circle
          cx="283.314"
          cy="89.6666"
          r="13.6807"
          transform="rotate(45 283.314 89.6666)"
          fill="#D04729"
        />
        <circle
          cx="272.833"
          cy="37.301"
          r="17.2421"
          transform="rotate(30 272.833 37.301)"
          fill="#D04729"
        />
        <circle cx="186.979" cy="321.53" r="13.6097" fill="#D04729" />
        <circle
          cx="231.189"
          cy="350.992"
          r="17.1526"
          transform="rotate(-15 231.189 350.992)"
          fill="#D04729"
        />
        <circle
          cx="283.312"
          cy="282.334"
          r="13.6807"
          transform="rotate(-45 283.312 282.334)"
          fill="#D04729"
        />
        <circle
          cx="335.678"
          cy="271.852"
          r="17.2421"
          transform="rotate(-60 335.678 271.852)"
          fill="#D04729"
        />
        <circle
          cx="51.4489"
          cy="186.001"
          r="13.6097"
          transform="rotate(90 51.4489 186.001)"
          fill="#D04729"
        />
        <circle
          cx="21.9865"
          cy="230.21"
          r="17.1526"
          transform="rotate(75 21.9865 230.21)"
          fill="#D04729"
        />
        <circle
          cx="90.6426"
          cy="282.334"
          r="13.6807"
          transform="rotate(45 90.6426 282.334)"
          fill="#D04729"
        />
        <circle
          cx="101.126"
          cy="334.7"
          r="17.2421"
          transform="rotate(30 101.126 334.7)"
          fill="#D04729"
        />
        <circle
          cx="134.136"
          cy="94.474"
          r="10.6127"
          transform="rotate(-30 134.136 94.474)"
          fill="#D04729"
        />
        <circle
          cx="84.3626"
          cy="158.504"
          r="10.6681"
          transform="rotate(-75 84.3626 158.504)"
          fill="#D04729"
        />
        <circle
          cx="278.504"
          cy="133.158"
          r="10.6127"
          transform="rotate(60 278.504 133.158)"
          fill="#D04729"
        />
        <circle
          cx="214.475"
          cy="83.3831"
          r="10.6681"
          transform="rotate(15 214.475 83.3831)"
          fill="#D04729"
        />
        <circle
          cx="239.822"
          cy="277.526"
          r="10.6127"
          transform="rotate(-30 239.822 277.526)"
          fill="#D04729"
        />
        <circle
          cx="289.595"
          cy="213.496"
          r="10.6681"
          transform="rotate(-75 289.595 213.496)"
          fill="#D04729"
        />
        <circle
          cx="95.4514"
          cy="238.843"
          r="10.6127"
          transform="rotate(60 95.4514 238.843)"
          fill="#D04729"
        />
        <circle
          cx="159.481"
          cy="288.618"
          r="10.6681"
          transform="rotate(15 159.481 288.618)"
          fill="#D04729"
        />
      </g>
    </svg>
  );
};

export default BookingErrorIcon;
